import React from 'react';
import AccordanceTrello from './AccordanceTrello';
import { NewAccordanceContextProvider } from '../../../../Util/Modals/NewAccordance/context/NewAccordanceContext';

type Props = {
  setAlertConfig?: Function;
};

const AccordanceTrelloWithContext = ({ setAlertConfig }: Props) => {
  return (
    <NewAccordanceContextProvider setAlertConfig={setAlertConfig}>
      <AccordanceTrello setAlertConfig={setAlertConfig} />
    </NewAccordanceContextProvider>
  );
};

export default AccordanceTrelloWithContext;
